import { render, staticRenderFns } from "./examination-question-modal.vue?vue&type=template&id=8ea8b41c"
import script from "./examination-question-modal.vue?vue&type=script&lang=js"
export * from "./examination-question-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports